import React from 'react';
import styled from 'styled-components';

const FloatingButton: React.FC<{ fullscreenGallery?: boolean }> = ({ fullscreenGallery }) => {
  const scrollToTop = () => {
    const container = document.querySelector('#scrollable-container');
    if (container && container.scrollTop > 0) {
      // Przewijanie w ScrollableContainer
      container.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Przewijanie w body/html (np. na urządzeniach mobilnych)
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (fullscreenGallery) return null;
  return <Button onClick={scrollToTop}>↑</Button>;
};

const Button = styled.button`
  position: fixed;
  bottom: 70px; /* Adjusted to avoid collision with the navbar */
  right: 20px;
  width: 50px;
  height: 50px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  font-size: 1.5rem;
  z-index: 1000;
  transition: background 0.3s, transform 0.2s;

  &:hover {
    background: #0056b3;
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
  }
`;

export default FloatingButton;